export enum ConversionValuesEnum {
	ZFT = 168,
	SGT = 216,
	PGT = 1040,
	PT = 857,
	Duo = 961,
}
